import { Note } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { Translation } from '../translations';
import { UnitOfMeasureType } from '../item/enum/UnitOfMeasureType';

export enum FinishingRouteStatus {
  Active = 0,
  Voided = 1,
  AwaitingQA = 2,
  QAApproved = 3,
}

export interface FinishingRoute extends AuditTrail {
  id?: string;
  productionCardReference: string;
  number: string; // Format: {ProductionCardNumber}-FR-{routeNumber}
  rollNumbers: string[];
  fabricCodes: string[];
  route: ProcessKey[];
  status: FinishingRouteStatus;
  notes?: Note[];
}

export enum ConsumedItemsStatus {
  Draft = 0,
  Completed = 1,
}

export interface ProcessKey {
  lineId: string;
  processId: string;
  dateTimeAdded?: Date | null;
  startTime?: Date | null;
  endTime?: Date | null;
  processName?: Translation;
  startStationAssetId?: string | null;
  endStationAssetId?: string | null;
  consumedItems?: ConsumedItem[];
  consumedItemsStatus?: ConsumedItemsStatus;
}

export interface ConsumedItem {
  itemCode: string;
  quantity: number;
  unitOfMeasure: UnitOfMeasureType;
  dateTimeAdded?: Date;
  modifiedBy?: string;
  itemDescription?: string;
  currentInventory?: number;
}

export interface ReorganizeProcessOption {
  id: string;
  name: string;
}

export interface ReorganizeProcessResult {
  pendingProcesses: ProcessKey[];
}
